import { useAPIQuery, UserHoopsApi } from "melco-shared-logic";
import { useBasicSettings } from "../../settings/useBasicSettings";

export const useHoopsDropdown = () => {
  const { settings, isLoading: isSettingsLoading } = useBasicSettings();

  const {
    data,
    isPreviousData,
    isFetching,
    isLoading: isQueryLoading,
  } = useAPIQuery(
    UserHoopsApi,
    ["hoopsDropdownData", settings?.measurement_unit],
    async (api) => {
      const response = await api.assetHoopsSearch({
        offset: 0,
        limit: 1000,
        sortBy: "name.asc",

        publishState: "published",
        productList: "Fusion",
      });

      // const options = (response.list ?? []).map((o) => ({
      //   value: o.id ?? "",
      //   label:
      //     (settings?.measurement_unit === "english"
      //       ? o?.name + o?.english_dimensions
      //       : o.name + o.metric_dimensions) ?? "",
      // }));

      const options = (response.list ?? []).map((o) => {
        const name = o?.name ?? "";
        const dimensions =
          settings?.measurement_unit === "english"
            ? o?.english_dimensions ?? ""
            : o?.metric_dimensions ?? "";

        return {
          value: o?.id ?? "",
          label: name + " " + dimensions,
        };
      });
      return options;
    },
    {
      queryOptions: {
        keepPreviousData: true,
        enabled: !!settings?.measurement_unit,
      },
    }
  );

  const isHoopLoading = isPreviousData ? isFetching : isQueryLoading;
  const isLoading = isHoopLoading || isSettingsLoading;

  return { isLoading, data: data ?? [] };
};
